import React, { useEffect } from 'react'
import Draggable from 'react-draggable'

const ModalCentroMonitoreo = ({
  isOpen, 
  closeModal, 
  children, 
  title, 
  clasesModal
}) => {
      useEffect(() => {
          const eventoEsc = (event) => {
              if (event.key === 'Escape') {
                  closeModal()
              }
          }
          document.addEventListener('keydown',eventoEsc)
          return(() => {
              document.removeEventListener('keydown',eventoEsc)
          })
      },[])
  
      return (
          <div className={isOpen ? '' : 'hidden'}>
                  <Draggable handle="strong">
                      <div className="justify-center items-center flex overflow-hidden fixed inset-0 z-[10000] outline-none focus:outline-none">
                          <div className={`${clasesModal ? clasesModal : ''} relative w-auto lg:w-full my-6 mx-auto max-w-[90%] max-h-[90vh] overflow-auto`} style={{boxShadow: 'rgb(0 0 0) 0px 0px 25px 8px'}}>
                          {/*content*/}
                              <div className="rounded-lg shadow-lg relative flex flex-col outline-none focus:outline-none w-[90vw] h-[90vh] overflow-auto">
                                  {/*header*/}
                                  <div className="bg-[#003478] flex items-start justify-between p-5 rounded-t">
                                      <h3 className="text-xl font-semibold">{title}</h3>
                                      <button
                                          className="cursor-pointer"
                                          onClick={closeModal}
                                          onTouchEnd={closeModal}         // PARA EL CLICK EN LA VISTA MOVIL
                                      >
                                          <i className="fas fa-times"></i>
                                      </button>
                                  </div>
                                  {/*body*/}
                                  <div className="relative p-6 bg-[#2f3134] flex-1 overflow-auto">
                                      { children }
                                  </div>
                              </div>
                          </div>
                      </div>
                  </Draggable>
          </div>
      );
}

export default ModalCentroMonitoreo